module.exports = __webpack_public_path__ + "img/logo-TRX.acda5878.svg";